export function int_to_bool(int: 0 | 1):boolean {
    return int === 1 ? true : false;
}
export function bool_to_int(bool: boolean): 0 | 1 {
    return bool === true ? 1 : 0;
}
export type BooleanOrInt = boolean | 0 | 1;
export function to_bool(value: BooleanOrInt): boolean {
    return value == true;
}